import { render, staticRenderFns } from "./header-layout.vue?vue&type=template&id=1c20431c&scoped=true"
import script from "./header-layout.vue?vue&type=script&lang=js"
export * from "./header-layout.vue?vue&type=script&lang=js"
import style0 from "./header-layout.vue?vue&type=style&index=0&id=1c20431c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20431c",
  null
  
)

export default component.exports